import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DatosCuestionario } from 'src/app/modelos/datos/datoscuestionario.model';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Datospregunta } from 'src/app/modelos/datos/datospregunta.model';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-realizadorcuestionario',
  templateUrl: './realizadorcuestionario.component.html',
  styleUrls: ['./realizadorcuestionario.component.css']
})
export class RealizadorcuestionarioComponent implements OnInit {
  public titulo: string="";
  public nombrerealizador: string = "";
  public accederActividad: boolean;
  public minutos: number = 0;
  public uid:string="";
  segundos: number = 0;
  interval;
  public claveActividad: string;
  public datosActividad: Observable<DatosCuestionario>;
  public descripcion:string;
  public preguntas:Array<Datospregunta>;
  public respuestaDistractores:Array<string>;
  public aciertos:number=0;
  public errores:number=0;
  public calificacion:number=0;
  constructor(public route: ActivatedRoute, public router: Router, private servicio: ServicioFirebaseService) { }

  ngOnInit() {
    this.route.params.forEach(params => {
      let clave = params["clave"];
      this.datosActividad = this.servicio.tomarInformacionActividadCuestionario(clave);
      this.datosActividad.subscribe(res => {
        this.titulo=res.titulo;
        this.uid=res.uid;
        this.descripcion = res.descripcion;
        this.preguntas= res.preguntas;
        this.preguntas.forEach((pregunta)=>{
          pregunta.distractores.push(pregunta.respuestaCorrecta);
          this.revolver(pregunta.distractores);
        });
      });

    })
   this.mostarModal("#myModal");
  }
  empezarActividad() {
    if (this.nombrerealizador != "") {
      this.esconderModal("#myModal");
      this.iniciarTimer();
      this.accederActividad = true;
    } else {
      this.accederActividad = false;

    }
  }
  revolver(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
  contestarPregunta(i,res){
    if(this.preguntas[i].respuestaCorrecta==res){
      this.aciertos++;
    }else{
      this.errores++
    }
    if(i==this.preguntas.length-1){
      this.terminarActividad();
    }else{
      $('.carousel').carousel('next');
    }
  }
  terminarActividad() {
    this.calificacion = Math.floor((this.aciertos / this.preguntas.length) * 100);
    this.pausarTimer();
    this.mostarModal("#myModal-calificacion");
    var tiempo = this.minutos.toString() + ":" + this.segundos.toString();
    this.servicio.registrarActividadHecha(this.calificacion.toString(),this.nombrerealizador,tiempo,"cuestionario",this.titulo,this.uid);
  }
  iniciarTimer() {
    this.interval = setInterval(() => {
      if (this.segundos == 59) {
        this.segundos = 0;
        this.minutos++;
      } else {
        this.segundos++;
      }
    }, 1000)
  }
  pausarTimer() {
    clearInterval(this.interval);
  }
  mostarModal(id: string): void {
    $(id).modal('show');
  }
  esconderModal(id: string) {
    $(id).modal('hide');
  }
}
